import { jsx as o } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "m44.25 49.3-9.98-9.99-2.83-2.82-2.83 2.82-2.57 2.58-6.53-22.4 22.44 6.48-2.64 2.64-2.82 2.83 2.82 2.83 9.99 9.98 4.46-1.2-11.62-11.61 7.43-7.43-35.94-10.38 10.46 35.86 7.35-7.35 12.81 12.81 6.24-6.24-1.19-4.46-5.05 5.05Z"
      }
    )
  }
);
export {
  t as Cursor
};
